import { render, staticRenderFns } from "./ItemControl.vue?vue&type=template&id=3c18fb45&scoped=true"
import script from "./ItemControl.vue?vue&type=script&lang=js"
export * from "./ItemControl.vue?vue&type=script&lang=js"
import style0 from "./ItemControl.vue?vue&type=style&index=0&id=3c18fb45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18fb45",
  null
  
)

export default component.exports